import React from 'react';
import { CheckCircle } from 'lucide-react';
import Modal from './Modal';
import Button from './Button';

interface SuccessfullModalProps {
  modalClassName?: string;
  children: React.ReactNode;
  modalMain?: string;
  onClick?: () => void;
  successfullOk?: () => void;
}

const SuccessfullModal = React.forwardRef<HTMLDivElement, SuccessfullModalProps>(({
  modalClassName,
  modalMain,
  children,
  onClick,
  successfullOk,
}, ref) => {
  return (
    <Modal
      ref={ref}
      modalMain={modalMain}
      onClick={onClick}
      size="sm"
      hideCloseButton
      modalClassName={`p-8 ${modalClassName ?? ""}`}
    >
      <div className="flex justify-center mb-4">
        <CheckCircle className="w-12 h-12 text-success" />
      </div>
      <h1 className="text-lg font-semibold leading-normal text-center font-inter text-foreground">
        {children}
      </h1>
      <Button
        type="button"
        onClick={successfullOk}
        variant="primary"
        buttonClasses="w-full mt-6 min-h-[44px]"
      >
        OK
      </Button>
    </Modal>
  );
});

export default SuccessfullModal;
